<div class="header-layout">
    <div>
        <h1>{{title()}}</h1>
    </div>
    
    @for (pageCommand of visiblePageCommands() ?? []; track pageCommand.name) {
        <app-link [disabled]="!hasPermission(pageCommand.requiredPermissions) || pageCommand.disabled" [iconClass]="pageCommand.icon" (onClick)="pageCommand.action()">{{pageCommand.text}}</app-link>
    }
</div> 
